/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SubmitRfqRouteImport } from './routes/submit-rfq'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as SellerProfileSetupRouteImport } from './routes/seller-profile-setup'
import { Route as SellerCompanySetupRouteImport } from './routes/seller-company-setup'
import { Route as RfqsRouteImport } from './routes/rfqs'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as QuotationsRouteImport } from './routes/quotations'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as ProductsRouteImport } from './routes/products'
import { Route as OverviewRouteImport } from './routes/overview'
import { Route as OrdersRouteImport } from './routes/orders'
import { Route as NotificationsRouteImport } from './routes/notifications'
import { Route as LogisticsRouteImport } from './routes/logistics'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as ExternalSellersRouteImport } from './routes/external-sellers'
import { Route as ExploreRouteImport } from './routes/explore'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as ComplaintsRouteImport } from './routes/complaints'
import { Route as CompaniesRouteImport } from './routes/companies'
import { Route as ChatRouteImport } from './routes/chat'
import { Route as BuyerProfileSetupRouteImport } from './routes/buyer-profile-setup'
import { Route as BrowseSupplierRouteImport } from './routes/browse-supplier'
import { Route as BrowseProductsRouteImport } from './routes/browse-products'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as IndexRouteImport } from './routes/index'
import { Route as RfqsRfqIdRouteImport } from './routes/rfqs.$rfqId'
import { Route as QuotationsQuotationIdRouteImport } from './routes/quotations.$quotationId'
import { Route as ProductsProductIdRouteImport } from './routes/products.$productId'
import { Route as OrdersOrderIdRouteImport } from './routes/orders.$orderId'
import { Route as ExternalSellersLeadIdRouteImport } from './routes/external-sellers.$leadId'
import { Route as ExploreSuppliersRouteImport } from './routes/explore.suppliers'
import { Route as ExploreProductsRouteImport } from './routes/explore.products'
import { Route as DashboardQuotationsRouteImport } from './routes/dashboard.quotations'
import { Route as DashboardProfileRouteImport } from './routes/dashboard.profile'
import { Route as DashboardOrdersRouteImport } from './routes/dashboard.orders'
import { Route as DashboardNotificationsRouteImport } from './routes/dashboard.notifications'
import { Route as DashboardComplaintsRouteImport } from './routes/dashboard.complaints'
import { Route as ComplaintsComplaintIdRouteImport } from './routes/complaints.$complaintId'
import { Route as CompaniesCompanyIdRouteImport } from './routes/companies.$companyId'
import { Route as ProductsVariantVariantIdRouteImport } from './routes/products.variant.$variantId'
import { Route as ExploreProductsProductIdRouteImport } from './routes/explore.products.$productId'
import { Route as ExploreCompaniesCompanyIdRouteImport } from './routes/explore.companies.$companyId'
import { Route as DashboardQuotationsRfqIdRouteImport } from './routes/dashboard.quotations.$rfqId'
import { Route as DashboardOrdersOrderIdRouteImport } from './routes/dashboard.orders.$orderId'
import { Route as DashboardComplaintsComplaintIdRouteImport } from './routes/dashboard.complaints.$complaintId'
import { Route as BrowseSupplierCompaniesCompanyIdRouteImport } from './routes/browse-supplier.companies.$companyId'
import { Route as BrowseProductsProductsProductIdRouteImport } from './routes/browse-products.products.$productId'
import { Route as ExploreProductsProductIdVariantsVariantIdRouteImport } from './routes/explore.products.$productId.variants.$variantId'
import { Route as BrowseProductsProductsProductIdVariantsVariantIdRouteImport } from './routes/browse-products.products.$productId.variants.$variantId'

const SubmitRfqRoute = SubmitRfqRouteImport.update({
  id: '/submit-rfq',
  path: '/submit-rfq',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/submit-rfq.lazy').then((d) => d.Route))
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/settings.lazy').then((d) => d.Route))
const SellerProfileSetupRoute = SellerProfileSetupRouteImport.update({
  id: '/seller-profile-setup',
  path: '/seller-profile-setup',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/seller-profile-setup.lazy').then((d) => d.Route),
)
const SellerCompanySetupRoute = SellerCompanySetupRouteImport.update({
  id: '/seller-company-setup',
  path: '/seller-company-setup',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/seller-company-setup.lazy').then((d) => d.Route),
)
const RfqsRoute = RfqsRouteImport.update({
  id: '/rfqs',
  path: '/rfqs',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/rfqs.lazy').then((d) => d.Route))
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const QuotationsRoute = QuotationsRouteImport.update({
  id: '/quotations',
  path: '/quotations',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/quotations.lazy').then((d) => d.Route))
const ProfileRoute = ProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/profile.lazy').then((d) => d.Route))
const ProductsRoute = ProductsRouteImport.update({
  id: '/products',
  path: '/products',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/products.lazy').then((d) => d.Route))
const OverviewRoute = OverviewRouteImport.update({
  id: '/overview',
  path: '/overview',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/overview.lazy').then((d) => d.Route))
const OrdersRoute = OrdersRouteImport.update({
  id: '/orders',
  path: '/orders',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/orders.lazy').then((d) => d.Route))
const NotificationsRoute = NotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/notifications.lazy').then((d) => d.Route))
const LogisticsRoute = LogisticsRouteImport.update({
  id: '/logistics',
  path: '/logistics',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/logistics.lazy').then((d) => d.Route))
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const ExternalSellersRoute = ExternalSellersRouteImport.update({
  id: '/external-sellers',
  path: '/external-sellers',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/external-sellers.lazy').then((d) => d.Route),
)
const ExploreRoute = ExploreRouteImport.update({
  id: '/explore',
  path: '/explore',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/explore.lazy').then((d) => d.Route))
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/dashboard.lazy').then((d) => d.Route))
const ComplaintsRoute = ComplaintsRouteImport.update({
  id: '/complaints',
  path: '/complaints',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/complaints.lazy').then((d) => d.Route))
const CompaniesRoute = CompaniesRouteImport.update({
  id: '/companies',
  path: '/companies',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/companies.lazy').then((d) => d.Route))
const ChatRoute = ChatRouteImport.update({
  id: '/chat',
  path: '/chat',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/chat.lazy').then((d) => d.Route))
const BuyerProfileSetupRoute = BuyerProfileSetupRouteImport.update({
  id: '/buyer-profile-setup',
  path: '/buyer-profile-setup',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/buyer-profile-setup.lazy').then((d) => d.Route),
)
const BrowseSupplierRoute = BrowseSupplierRouteImport.update({
  id: '/browse-supplier',
  path: '/browse-supplier',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/browse-supplier.lazy').then((d) => d.Route),
)
const BrowseProductsRoute = BrowseProductsRouteImport.update({
  id: '/browse-products',
  path: '/browse-products',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/browse-products.lazy').then((d) => d.Route),
)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const RfqsRfqIdRoute = RfqsRfqIdRouteImport.update({
  id: '/$rfqId',
  path: '/$rfqId',
  getParentRoute: () => RfqsRoute,
} as any)
const QuotationsQuotationIdRoute = QuotationsQuotationIdRouteImport.update({
  id: '/$quotationId',
  path: '/$quotationId',
  getParentRoute: () => QuotationsRoute,
} as any)
const ProductsProductIdRoute = ProductsProductIdRouteImport.update({
  id: '/$productId',
  path: '/$productId',
  getParentRoute: () => ProductsRoute,
} as any)
const OrdersOrderIdRoute = OrdersOrderIdRouteImport.update({
  id: '/$orderId',
  path: '/$orderId',
  getParentRoute: () => OrdersRoute,
} as any)
const ExternalSellersLeadIdRoute = ExternalSellersLeadIdRouteImport.update({
  id: '/$leadId',
  path: '/$leadId',
  getParentRoute: () => ExternalSellersRoute,
} as any)
const ExploreSuppliersRoute = ExploreSuppliersRouteImport.update({
  id: '/suppliers',
  path: '/suppliers',
  getParentRoute: () => ExploreRoute,
} as any).lazy(() =>
  import('./routes/explore.suppliers.lazy').then((d) => d.Route),
)
const ExploreProductsRoute = ExploreProductsRouteImport.update({
  id: '/products',
  path: '/products',
  getParentRoute: () => ExploreRoute,
} as any).lazy(() =>
  import('./routes/explore.products.lazy').then((d) => d.Route),
)
const DashboardQuotationsRoute = DashboardQuotationsRouteImport.update({
  id: '/quotations',
  path: '/quotations',
  getParentRoute: () => DashboardRoute,
} as any).lazy(() =>
  import('./routes/dashboard.quotations.lazy').then((d) => d.Route),
)
const DashboardProfileRoute = DashboardProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => DashboardRoute,
} as any).lazy(() =>
  import('./routes/dashboard.profile.lazy').then((d) => d.Route),
)
const DashboardOrdersRoute = DashboardOrdersRouteImport.update({
  id: '/orders',
  path: '/orders',
  getParentRoute: () => DashboardRoute,
} as any).lazy(() =>
  import('./routes/dashboard.orders.lazy').then((d) => d.Route),
)
const DashboardNotificationsRoute = DashboardNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => DashboardRoute,
} as any).lazy(() =>
  import('./routes/dashboard.notifications.lazy').then((d) => d.Route),
)
const DashboardComplaintsRoute = DashboardComplaintsRouteImport.update({
  id: '/complaints',
  path: '/complaints',
  getParentRoute: () => DashboardRoute,
} as any).lazy(() =>
  import('./routes/dashboard.complaints.lazy').then((d) => d.Route),
)
const ComplaintsComplaintIdRoute = ComplaintsComplaintIdRouteImport.update({
  id: '/$complaintId',
  path: '/$complaintId',
  getParentRoute: () => ComplaintsRoute,
} as any)
const CompaniesCompanyIdRoute = CompaniesCompanyIdRouteImport.update({
  id: '/$companyId',
  path: '/$companyId',
  getParentRoute: () => CompaniesRoute,
} as any)
const ProductsVariantVariantIdRoute =
  ProductsVariantVariantIdRouteImport.update({
    id: '/variant/$variantId',
    path: '/variant/$variantId',
    getParentRoute: () => ProductsRoute,
  } as any)
const ExploreProductsProductIdRoute =
  ExploreProductsProductIdRouteImport.update({
    id: '/$productId',
    path: '/$productId',
    getParentRoute: () => ExploreProductsRoute,
  } as any)
const ExploreCompaniesCompanyIdRoute =
  ExploreCompaniesCompanyIdRouteImport.update({
    id: '/companies/$companyId',
    path: '/companies/$companyId',
    getParentRoute: () => ExploreRoute,
  } as any)
const DashboardQuotationsRfqIdRoute =
  DashboardQuotationsRfqIdRouteImport.update({
    id: '/$rfqId',
    path: '/$rfqId',
    getParentRoute: () => DashboardQuotationsRoute,
  } as any).lazy(() =>
    import('./routes/dashboard.quotations.$rfqId.lazy').then((d) => d.Route),
  )
const DashboardOrdersOrderIdRoute = DashboardOrdersOrderIdRouteImport.update({
  id: '/$orderId',
  path: '/$orderId',
  getParentRoute: () => DashboardOrdersRoute,
} as any).lazy(() =>
  import('./routes/dashboard.orders.$orderId.lazy').then((d) => d.Route),
)
const DashboardComplaintsComplaintIdRoute =
  DashboardComplaintsComplaintIdRouteImport.update({
    id: '/$complaintId',
    path: '/$complaintId',
    getParentRoute: () => DashboardComplaintsRoute,
  } as any).lazy(() =>
    import('./routes/dashboard.complaints.$complaintId.lazy').then(
      (d) => d.Route,
    ),
  )
const BrowseSupplierCompaniesCompanyIdRoute =
  BrowseSupplierCompaniesCompanyIdRouteImport.update({
    id: '/companies/$companyId',
    path: '/companies/$companyId',
    getParentRoute: () => BrowseSupplierRoute,
  } as any)
const BrowseProductsProductsProductIdRoute =
  BrowseProductsProductsProductIdRouteImport.update({
    id: '/products/$productId',
    path: '/products/$productId',
    getParentRoute: () => BrowseProductsRoute,
  } as any)
const ExploreProductsProductIdVariantsVariantIdRoute =
  ExploreProductsProductIdVariantsVariantIdRouteImport.update({
    id: '/variants/$variantId',
    path: '/variants/$variantId',
    getParentRoute: () => ExploreProductsProductIdRoute,
  } as any)
const BrowseProductsProductsProductIdVariantsVariantIdRoute =
  BrowseProductsProductsProductIdVariantsVariantIdRouteImport.update({
    id: '/variants/$variantId',
    path: '/variants/$variantId',
    getParentRoute: () => BrowseProductsProductsProductIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/browse-products': typeof BrowseProductsRouteWithChildren
  '/browse-supplier': typeof BrowseSupplierRouteWithChildren
  '/buyer-profile-setup': typeof BuyerProfileSetupRoute
  '/chat': typeof ChatRoute
  '/companies': typeof CompaniesRouteWithChildren
  '/complaints': typeof ComplaintsRouteWithChildren
  '/dashboard': typeof DashboardRouteWithChildren
  '/explore': typeof ExploreRouteWithChildren
  '/external-sellers': typeof ExternalSellersRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/logistics': typeof LogisticsRoute
  '/notifications': typeof NotificationsRoute
  '/orders': typeof OrdersRouteWithChildren
  '/overview': typeof OverviewRoute
  '/products': typeof ProductsRouteWithChildren
  '/profile': typeof ProfileRoute
  '/quotations': typeof QuotationsRouteWithChildren
  '/reset-password': typeof ResetPasswordRoute
  '/rfqs': typeof RfqsRouteWithChildren
  '/seller-company-setup': typeof SellerCompanySetupRoute
  '/seller-profile-setup': typeof SellerProfileSetupRoute
  '/settings': typeof SettingsRoute
  '/signup': typeof SignupRoute
  '/submit-rfq': typeof SubmitRfqRoute
  '/companies/$companyId': typeof CompaniesCompanyIdRoute
  '/complaints/$complaintId': typeof ComplaintsComplaintIdRoute
  '/dashboard/complaints': typeof DashboardComplaintsRouteWithChildren
  '/dashboard/notifications': typeof DashboardNotificationsRoute
  '/dashboard/orders': typeof DashboardOrdersRouteWithChildren
  '/dashboard/profile': typeof DashboardProfileRoute
  '/dashboard/quotations': typeof DashboardQuotationsRouteWithChildren
  '/explore/products': typeof ExploreProductsRouteWithChildren
  '/explore/suppliers': typeof ExploreSuppliersRoute
  '/external-sellers/$leadId': typeof ExternalSellersLeadIdRoute
  '/orders/$orderId': typeof OrdersOrderIdRoute
  '/products/$productId': typeof ProductsProductIdRoute
  '/quotations/$quotationId': typeof QuotationsQuotationIdRoute
  '/rfqs/$rfqId': typeof RfqsRfqIdRoute
  '/browse-products/products/$productId': typeof BrowseProductsProductsProductIdRouteWithChildren
  '/browse-supplier/companies/$companyId': typeof BrowseSupplierCompaniesCompanyIdRoute
  '/dashboard/complaints/$complaintId': typeof DashboardComplaintsComplaintIdRoute
  '/dashboard/orders/$orderId': typeof DashboardOrdersOrderIdRoute
  '/dashboard/quotations/$rfqId': typeof DashboardQuotationsRfqIdRoute
  '/explore/companies/$companyId': typeof ExploreCompaniesCompanyIdRoute
  '/explore/products/$productId': typeof ExploreProductsProductIdRouteWithChildren
  '/products/variant/$variantId': typeof ProductsVariantVariantIdRoute
  '/browse-products/products/$productId/variants/$variantId': typeof BrowseProductsProductsProductIdVariantsVariantIdRoute
  '/explore/products/$productId/variants/$variantId': typeof ExploreProductsProductIdVariantsVariantIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/browse-products': typeof BrowseProductsRouteWithChildren
  '/browse-supplier': typeof BrowseSupplierRouteWithChildren
  '/buyer-profile-setup': typeof BuyerProfileSetupRoute
  '/chat': typeof ChatRoute
  '/companies': typeof CompaniesRouteWithChildren
  '/complaints': typeof ComplaintsRouteWithChildren
  '/dashboard': typeof DashboardRouteWithChildren
  '/explore': typeof ExploreRouteWithChildren
  '/external-sellers': typeof ExternalSellersRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/logistics': typeof LogisticsRoute
  '/notifications': typeof NotificationsRoute
  '/orders': typeof OrdersRouteWithChildren
  '/overview': typeof OverviewRoute
  '/products': typeof ProductsRouteWithChildren
  '/profile': typeof ProfileRoute
  '/quotations': typeof QuotationsRouteWithChildren
  '/reset-password': typeof ResetPasswordRoute
  '/rfqs': typeof RfqsRouteWithChildren
  '/seller-company-setup': typeof SellerCompanySetupRoute
  '/seller-profile-setup': typeof SellerProfileSetupRoute
  '/settings': typeof SettingsRoute
  '/signup': typeof SignupRoute
  '/submit-rfq': typeof SubmitRfqRoute
  '/companies/$companyId': typeof CompaniesCompanyIdRoute
  '/complaints/$complaintId': typeof ComplaintsComplaintIdRoute
  '/dashboard/complaints': typeof DashboardComplaintsRouteWithChildren
  '/dashboard/notifications': typeof DashboardNotificationsRoute
  '/dashboard/orders': typeof DashboardOrdersRouteWithChildren
  '/dashboard/profile': typeof DashboardProfileRoute
  '/dashboard/quotations': typeof DashboardQuotationsRouteWithChildren
  '/explore/products': typeof ExploreProductsRouteWithChildren
  '/explore/suppliers': typeof ExploreSuppliersRoute
  '/external-sellers/$leadId': typeof ExternalSellersLeadIdRoute
  '/orders/$orderId': typeof OrdersOrderIdRoute
  '/products/$productId': typeof ProductsProductIdRoute
  '/quotations/$quotationId': typeof QuotationsQuotationIdRoute
  '/rfqs/$rfqId': typeof RfqsRfqIdRoute
  '/browse-products/products/$productId': typeof BrowseProductsProductsProductIdRouteWithChildren
  '/browse-supplier/companies/$companyId': typeof BrowseSupplierCompaniesCompanyIdRoute
  '/dashboard/complaints/$complaintId': typeof DashboardComplaintsComplaintIdRoute
  '/dashboard/orders/$orderId': typeof DashboardOrdersOrderIdRoute
  '/dashboard/quotations/$rfqId': typeof DashboardQuotationsRfqIdRoute
  '/explore/companies/$companyId': typeof ExploreCompaniesCompanyIdRoute
  '/explore/products/$productId': typeof ExploreProductsProductIdRouteWithChildren
  '/products/variant/$variantId': typeof ProductsVariantVariantIdRoute
  '/browse-products/products/$productId/variants/$variantId': typeof BrowseProductsProductsProductIdVariantsVariantIdRoute
  '/explore/products/$productId/variants/$variantId': typeof ExploreProductsProductIdVariantsVariantIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/browse-products': typeof BrowseProductsRouteWithChildren
  '/browse-supplier': typeof BrowseSupplierRouteWithChildren
  '/buyer-profile-setup': typeof BuyerProfileSetupRoute
  '/chat': typeof ChatRoute
  '/companies': typeof CompaniesRouteWithChildren
  '/complaints': typeof ComplaintsRouteWithChildren
  '/dashboard': typeof DashboardRouteWithChildren
  '/explore': typeof ExploreRouteWithChildren
  '/external-sellers': typeof ExternalSellersRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/logistics': typeof LogisticsRoute
  '/notifications': typeof NotificationsRoute
  '/orders': typeof OrdersRouteWithChildren
  '/overview': typeof OverviewRoute
  '/products': typeof ProductsRouteWithChildren
  '/profile': typeof ProfileRoute
  '/quotations': typeof QuotationsRouteWithChildren
  '/reset-password': typeof ResetPasswordRoute
  '/rfqs': typeof RfqsRouteWithChildren
  '/seller-company-setup': typeof SellerCompanySetupRoute
  '/seller-profile-setup': typeof SellerProfileSetupRoute
  '/settings': typeof SettingsRoute
  '/signup': typeof SignupRoute
  '/submit-rfq': typeof SubmitRfqRoute
  '/companies/$companyId': typeof CompaniesCompanyIdRoute
  '/complaints/$complaintId': typeof ComplaintsComplaintIdRoute
  '/dashboard/complaints': typeof DashboardComplaintsRouteWithChildren
  '/dashboard/notifications': typeof DashboardNotificationsRoute
  '/dashboard/orders': typeof DashboardOrdersRouteWithChildren
  '/dashboard/profile': typeof DashboardProfileRoute
  '/dashboard/quotations': typeof DashboardQuotationsRouteWithChildren
  '/explore/products': typeof ExploreProductsRouteWithChildren
  '/explore/suppliers': typeof ExploreSuppliersRoute
  '/external-sellers/$leadId': typeof ExternalSellersLeadIdRoute
  '/orders/$orderId': typeof OrdersOrderIdRoute
  '/products/$productId': typeof ProductsProductIdRoute
  '/quotations/$quotationId': typeof QuotationsQuotationIdRoute
  '/rfqs/$rfqId': typeof RfqsRfqIdRoute
  '/browse-products/products/$productId': typeof BrowseProductsProductsProductIdRouteWithChildren
  '/browse-supplier/companies/$companyId': typeof BrowseSupplierCompaniesCompanyIdRoute
  '/dashboard/complaints/$complaintId': typeof DashboardComplaintsComplaintIdRoute
  '/dashboard/orders/$orderId': typeof DashboardOrdersOrderIdRoute
  '/dashboard/quotations/$rfqId': typeof DashboardQuotationsRfqIdRoute
  '/explore/companies/$companyId': typeof ExploreCompaniesCompanyIdRoute
  '/explore/products/$productId': typeof ExploreProductsProductIdRouteWithChildren
  '/products/variant/$variantId': typeof ProductsVariantVariantIdRoute
  '/browse-products/products/$productId/variants/$variantId': typeof BrowseProductsProductsProductIdVariantsVariantIdRoute
  '/explore/products/$productId/variants/$variantId': typeof ExploreProductsProductIdVariantsVariantIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/browse-products'
    | '/browse-supplier'
    | '/buyer-profile-setup'
    | '/chat'
    | '/companies'
    | '/complaints'
    | '/dashboard'
    | '/explore'
    | '/external-sellers'
    | '/forgot-password'
    | '/login'
    | '/logistics'
    | '/notifications'
    | '/orders'
    | '/overview'
    | '/products'
    | '/profile'
    | '/quotations'
    | '/reset-password'
    | '/rfqs'
    | '/seller-company-setup'
    | '/seller-profile-setup'
    | '/settings'
    | '/signup'
    | '/submit-rfq'
    | '/companies/$companyId'
    | '/complaints/$complaintId'
    | '/dashboard/complaints'
    | '/dashboard/notifications'
    | '/dashboard/orders'
    | '/dashboard/profile'
    | '/dashboard/quotations'
    | '/explore/products'
    | '/explore/suppliers'
    | '/external-sellers/$leadId'
    | '/orders/$orderId'
    | '/products/$productId'
    | '/quotations/$quotationId'
    | '/rfqs/$rfqId'
    | '/browse-products/products/$productId'
    | '/browse-supplier/companies/$companyId'
    | '/dashboard/complaints/$complaintId'
    | '/dashboard/orders/$orderId'
    | '/dashboard/quotations/$rfqId'
    | '/explore/companies/$companyId'
    | '/explore/products/$productId'
    | '/products/variant/$variantId'
    | '/browse-products/products/$productId/variants/$variantId'
    | '/explore/products/$productId/variants/$variantId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/admin'
    | '/browse-products'
    | '/browse-supplier'
    | '/buyer-profile-setup'
    | '/chat'
    | '/companies'
    | '/complaints'
    | '/dashboard'
    | '/explore'
    | '/external-sellers'
    | '/forgot-password'
    | '/login'
    | '/logistics'
    | '/notifications'
    | '/orders'
    | '/overview'
    | '/products'
    | '/profile'
    | '/quotations'
    | '/reset-password'
    | '/rfqs'
    | '/seller-company-setup'
    | '/seller-profile-setup'
    | '/settings'
    | '/signup'
    | '/submit-rfq'
    | '/companies/$companyId'
    | '/complaints/$complaintId'
    | '/dashboard/complaints'
    | '/dashboard/notifications'
    | '/dashboard/orders'
    | '/dashboard/profile'
    | '/dashboard/quotations'
    | '/explore/products'
    | '/explore/suppliers'
    | '/external-sellers/$leadId'
    | '/orders/$orderId'
    | '/products/$productId'
    | '/quotations/$quotationId'
    | '/rfqs/$rfqId'
    | '/browse-products/products/$productId'
    | '/browse-supplier/companies/$companyId'
    | '/dashboard/complaints/$complaintId'
    | '/dashboard/orders/$orderId'
    | '/dashboard/quotations/$rfqId'
    | '/explore/companies/$companyId'
    | '/explore/products/$productId'
    | '/products/variant/$variantId'
    | '/browse-products/products/$productId/variants/$variantId'
    | '/explore/products/$productId/variants/$variantId'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/browse-products'
    | '/browse-supplier'
    | '/buyer-profile-setup'
    | '/chat'
    | '/companies'
    | '/complaints'
    | '/dashboard'
    | '/explore'
    | '/external-sellers'
    | '/forgot-password'
    | '/login'
    | '/logistics'
    | '/notifications'
    | '/orders'
    | '/overview'
    | '/products'
    | '/profile'
    | '/quotations'
    | '/reset-password'
    | '/rfqs'
    | '/seller-company-setup'
    | '/seller-profile-setup'
    | '/settings'
    | '/signup'
    | '/submit-rfq'
    | '/companies/$companyId'
    | '/complaints/$complaintId'
    | '/dashboard/complaints'
    | '/dashboard/notifications'
    | '/dashboard/orders'
    | '/dashboard/profile'
    | '/dashboard/quotations'
    | '/explore/products'
    | '/explore/suppliers'
    | '/external-sellers/$leadId'
    | '/orders/$orderId'
    | '/products/$productId'
    | '/quotations/$quotationId'
    | '/rfqs/$rfqId'
    | '/browse-products/products/$productId'
    | '/browse-supplier/companies/$companyId'
    | '/dashboard/complaints/$complaintId'
    | '/dashboard/orders/$orderId'
    | '/dashboard/quotations/$rfqId'
    | '/explore/companies/$companyId'
    | '/explore/products/$productId'
    | '/products/variant/$variantId'
    | '/browse-products/products/$productId/variants/$variantId'
    | '/explore/products/$productId/variants/$variantId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRoute
  BrowseProductsRoute: typeof BrowseProductsRouteWithChildren
  BrowseSupplierRoute: typeof BrowseSupplierRouteWithChildren
  BuyerProfileSetupRoute: typeof BuyerProfileSetupRoute
  ChatRoute: typeof ChatRoute
  CompaniesRoute: typeof CompaniesRouteWithChildren
  ComplaintsRoute: typeof ComplaintsRouteWithChildren
  DashboardRoute: typeof DashboardRouteWithChildren
  ExploreRoute: typeof ExploreRouteWithChildren
  ExternalSellersRoute: typeof ExternalSellersRouteWithChildren
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  LogisticsRoute: typeof LogisticsRoute
  NotificationsRoute: typeof NotificationsRoute
  OrdersRoute: typeof OrdersRouteWithChildren
  OverviewRoute: typeof OverviewRoute
  ProductsRoute: typeof ProductsRouteWithChildren
  ProfileRoute: typeof ProfileRoute
  QuotationsRoute: typeof QuotationsRouteWithChildren
  ResetPasswordRoute: typeof ResetPasswordRoute
  RfqsRoute: typeof RfqsRouteWithChildren
  SellerCompanySetupRoute: typeof SellerCompanySetupRoute
  SellerProfileSetupRoute: typeof SellerProfileSetupRoute
  SettingsRoute: typeof SettingsRoute
  SignupRoute: typeof SignupRoute
  SubmitRfqRoute: typeof SubmitRfqRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/submit-rfq': {
      id: '/submit-rfq'
      path: '/submit-rfq'
      fullPath: '/submit-rfq'
      preLoaderRoute: typeof SubmitRfqRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/seller-profile-setup': {
      id: '/seller-profile-setup'
      path: '/seller-profile-setup'
      fullPath: '/seller-profile-setup'
      preLoaderRoute: typeof SellerProfileSetupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/seller-company-setup': {
      id: '/seller-company-setup'
      path: '/seller-company-setup'
      fullPath: '/seller-company-setup'
      preLoaderRoute: typeof SellerCompanySetupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/rfqs': {
      id: '/rfqs'
      path: '/rfqs'
      fullPath: '/rfqs'
      preLoaderRoute: typeof RfqsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/quotations': {
      id: '/quotations'
      path: '/quotations'
      fullPath: '/quotations'
      preLoaderRoute: typeof QuotationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile': {
      id: '/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/products': {
      id: '/products'
      path: '/products'
      fullPath: '/products'
      preLoaderRoute: typeof ProductsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/overview': {
      id: '/overview'
      path: '/overview'
      fullPath: '/overview'
      preLoaderRoute: typeof OverviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/orders': {
      id: '/orders'
      path: '/orders'
      fullPath: '/orders'
      preLoaderRoute: typeof OrdersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/notifications': {
      id: '/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof NotificationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/logistics': {
      id: '/logistics'
      path: '/logistics'
      fullPath: '/logistics'
      preLoaderRoute: typeof LogisticsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/external-sellers': {
      id: '/external-sellers'
      path: '/external-sellers'
      fullPath: '/external-sellers'
      preLoaderRoute: typeof ExternalSellersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/explore': {
      id: '/explore'
      path: '/explore'
      fullPath: '/explore'
      preLoaderRoute: typeof ExploreRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/complaints': {
      id: '/complaints'
      path: '/complaints'
      fullPath: '/complaints'
      preLoaderRoute: typeof ComplaintsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/companies': {
      id: '/companies'
      path: '/companies'
      fullPath: '/companies'
      preLoaderRoute: typeof CompaniesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/chat': {
      id: '/chat'
      path: '/chat'
      fullPath: '/chat'
      preLoaderRoute: typeof ChatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/buyer-profile-setup': {
      id: '/buyer-profile-setup'
      path: '/buyer-profile-setup'
      fullPath: '/buyer-profile-setup'
      preLoaderRoute: typeof BuyerProfileSetupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/browse-supplier': {
      id: '/browse-supplier'
      path: '/browse-supplier'
      fullPath: '/browse-supplier'
      preLoaderRoute: typeof BrowseSupplierRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/browse-products': {
      id: '/browse-products'
      path: '/browse-products'
      fullPath: '/browse-products'
      preLoaderRoute: typeof BrowseProductsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/rfqs/$rfqId': {
      id: '/rfqs/$rfqId'
      path: '/$rfqId'
      fullPath: '/rfqs/$rfqId'
      preLoaderRoute: typeof RfqsRfqIdRouteImport
      parentRoute: typeof RfqsRoute
    }
    '/quotations/$quotationId': {
      id: '/quotations/$quotationId'
      path: '/$quotationId'
      fullPath: '/quotations/$quotationId'
      preLoaderRoute: typeof QuotationsQuotationIdRouteImport
      parentRoute: typeof QuotationsRoute
    }
    '/products/$productId': {
      id: '/products/$productId'
      path: '/$productId'
      fullPath: '/products/$productId'
      preLoaderRoute: typeof ProductsProductIdRouteImport
      parentRoute: typeof ProductsRoute
    }
    '/orders/$orderId': {
      id: '/orders/$orderId'
      path: '/$orderId'
      fullPath: '/orders/$orderId'
      preLoaderRoute: typeof OrdersOrderIdRouteImport
      parentRoute: typeof OrdersRoute
    }
    '/external-sellers/$leadId': {
      id: '/external-sellers/$leadId'
      path: '/$leadId'
      fullPath: '/external-sellers/$leadId'
      preLoaderRoute: typeof ExternalSellersLeadIdRouteImport
      parentRoute: typeof ExternalSellersRoute
    }
    '/explore/suppliers': {
      id: '/explore/suppliers'
      path: '/suppliers'
      fullPath: '/explore/suppliers'
      preLoaderRoute: typeof ExploreSuppliersRouteImport
      parentRoute: typeof ExploreRoute
    }
    '/explore/products': {
      id: '/explore/products'
      path: '/products'
      fullPath: '/explore/products'
      preLoaderRoute: typeof ExploreProductsRouteImport
      parentRoute: typeof ExploreRoute
    }
    '/dashboard/quotations': {
      id: '/dashboard/quotations'
      path: '/quotations'
      fullPath: '/dashboard/quotations'
      preLoaderRoute: typeof DashboardQuotationsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/profile': {
      id: '/dashboard/profile'
      path: '/profile'
      fullPath: '/dashboard/profile'
      preLoaderRoute: typeof DashboardProfileRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/orders': {
      id: '/dashboard/orders'
      path: '/orders'
      fullPath: '/dashboard/orders'
      preLoaderRoute: typeof DashboardOrdersRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/notifications': {
      id: '/dashboard/notifications'
      path: '/notifications'
      fullPath: '/dashboard/notifications'
      preLoaderRoute: typeof DashboardNotificationsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/complaints': {
      id: '/dashboard/complaints'
      path: '/complaints'
      fullPath: '/dashboard/complaints'
      preLoaderRoute: typeof DashboardComplaintsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/complaints/$complaintId': {
      id: '/complaints/$complaintId'
      path: '/$complaintId'
      fullPath: '/complaints/$complaintId'
      preLoaderRoute: typeof ComplaintsComplaintIdRouteImport
      parentRoute: typeof ComplaintsRoute
    }
    '/companies/$companyId': {
      id: '/companies/$companyId'
      path: '/$companyId'
      fullPath: '/companies/$companyId'
      preLoaderRoute: typeof CompaniesCompanyIdRouteImport
      parentRoute: typeof CompaniesRoute
    }
    '/products/variant/$variantId': {
      id: '/products/variant/$variantId'
      path: '/variant/$variantId'
      fullPath: '/products/variant/$variantId'
      preLoaderRoute: typeof ProductsVariantVariantIdRouteImport
      parentRoute: typeof ProductsRoute
    }
    '/explore/products/$productId': {
      id: '/explore/products/$productId'
      path: '/$productId'
      fullPath: '/explore/products/$productId'
      preLoaderRoute: typeof ExploreProductsProductIdRouteImport
      parentRoute: typeof ExploreProductsRoute
    }
    '/explore/companies/$companyId': {
      id: '/explore/companies/$companyId'
      path: '/companies/$companyId'
      fullPath: '/explore/companies/$companyId'
      preLoaderRoute: typeof ExploreCompaniesCompanyIdRouteImport
      parentRoute: typeof ExploreRoute
    }
    '/dashboard/quotations/$rfqId': {
      id: '/dashboard/quotations/$rfqId'
      path: '/$rfqId'
      fullPath: '/dashboard/quotations/$rfqId'
      preLoaderRoute: typeof DashboardQuotationsRfqIdRouteImport
      parentRoute: typeof DashboardQuotationsRoute
    }
    '/dashboard/orders/$orderId': {
      id: '/dashboard/orders/$orderId'
      path: '/$orderId'
      fullPath: '/dashboard/orders/$orderId'
      preLoaderRoute: typeof DashboardOrdersOrderIdRouteImport
      parentRoute: typeof DashboardOrdersRoute
    }
    '/dashboard/complaints/$complaintId': {
      id: '/dashboard/complaints/$complaintId'
      path: '/$complaintId'
      fullPath: '/dashboard/complaints/$complaintId'
      preLoaderRoute: typeof DashboardComplaintsComplaintIdRouteImport
      parentRoute: typeof DashboardComplaintsRoute
    }
    '/browse-supplier/companies/$companyId': {
      id: '/browse-supplier/companies/$companyId'
      path: '/companies/$companyId'
      fullPath: '/browse-supplier/companies/$companyId'
      preLoaderRoute: typeof BrowseSupplierCompaniesCompanyIdRouteImport
      parentRoute: typeof BrowseSupplierRoute
    }
    '/browse-products/products/$productId': {
      id: '/browse-products/products/$productId'
      path: '/products/$productId'
      fullPath: '/browse-products/products/$productId'
      preLoaderRoute: typeof BrowseProductsProductsProductIdRouteImport
      parentRoute: typeof BrowseProductsRoute
    }
    '/explore/products/$productId/variants/$variantId': {
      id: '/explore/products/$productId/variants/$variantId'
      path: '/variants/$variantId'
      fullPath: '/explore/products/$productId/variants/$variantId'
      preLoaderRoute: typeof ExploreProductsProductIdVariantsVariantIdRouteImport
      parentRoute: typeof ExploreProductsProductIdRoute
    }
    '/browse-products/products/$productId/variants/$variantId': {
      id: '/browse-products/products/$productId/variants/$variantId'
      path: '/variants/$variantId'
      fullPath: '/browse-products/products/$productId/variants/$variantId'
      preLoaderRoute: typeof BrowseProductsProductsProductIdVariantsVariantIdRouteImport
      parentRoute: typeof BrowseProductsProductsProductIdRoute
    }
  }
}

interface BrowseProductsProductsProductIdRouteChildren {
  BrowseProductsProductsProductIdVariantsVariantIdRoute: typeof BrowseProductsProductsProductIdVariantsVariantIdRoute
}

const BrowseProductsProductsProductIdRouteChildren: BrowseProductsProductsProductIdRouteChildren =
  {
    BrowseProductsProductsProductIdVariantsVariantIdRoute:
      BrowseProductsProductsProductIdVariantsVariantIdRoute,
  }

const BrowseProductsProductsProductIdRouteWithChildren =
  BrowseProductsProductsProductIdRoute._addFileChildren(
    BrowseProductsProductsProductIdRouteChildren,
  )

interface BrowseProductsRouteChildren {
  BrowseProductsProductsProductIdRoute: typeof BrowseProductsProductsProductIdRouteWithChildren
}

const BrowseProductsRouteChildren: BrowseProductsRouteChildren = {
  BrowseProductsProductsProductIdRoute:
    BrowseProductsProductsProductIdRouteWithChildren,
}

const BrowseProductsRouteWithChildren = BrowseProductsRoute._addFileChildren(
  BrowseProductsRouteChildren,
)

interface BrowseSupplierRouteChildren {
  BrowseSupplierCompaniesCompanyIdRoute: typeof BrowseSupplierCompaniesCompanyIdRoute
}

const BrowseSupplierRouteChildren: BrowseSupplierRouteChildren = {
  BrowseSupplierCompaniesCompanyIdRoute: BrowseSupplierCompaniesCompanyIdRoute,
}

const BrowseSupplierRouteWithChildren = BrowseSupplierRoute._addFileChildren(
  BrowseSupplierRouteChildren,
)

interface CompaniesRouteChildren {
  CompaniesCompanyIdRoute: typeof CompaniesCompanyIdRoute
}

const CompaniesRouteChildren: CompaniesRouteChildren = {
  CompaniesCompanyIdRoute: CompaniesCompanyIdRoute,
}

const CompaniesRouteWithChildren = CompaniesRoute._addFileChildren(
  CompaniesRouteChildren,
)

interface ComplaintsRouteChildren {
  ComplaintsComplaintIdRoute: typeof ComplaintsComplaintIdRoute
}

const ComplaintsRouteChildren: ComplaintsRouteChildren = {
  ComplaintsComplaintIdRoute: ComplaintsComplaintIdRoute,
}

const ComplaintsRouteWithChildren = ComplaintsRoute._addFileChildren(
  ComplaintsRouteChildren,
)

interface DashboardComplaintsRouteChildren {
  DashboardComplaintsComplaintIdRoute: typeof DashboardComplaintsComplaintIdRoute
}

const DashboardComplaintsRouteChildren: DashboardComplaintsRouteChildren = {
  DashboardComplaintsComplaintIdRoute: DashboardComplaintsComplaintIdRoute,
}

const DashboardComplaintsRouteWithChildren =
  DashboardComplaintsRoute._addFileChildren(DashboardComplaintsRouteChildren)

interface DashboardOrdersRouteChildren {
  DashboardOrdersOrderIdRoute: typeof DashboardOrdersOrderIdRoute
}

const DashboardOrdersRouteChildren: DashboardOrdersRouteChildren = {
  DashboardOrdersOrderIdRoute: DashboardOrdersOrderIdRoute,
}

const DashboardOrdersRouteWithChildren = DashboardOrdersRoute._addFileChildren(
  DashboardOrdersRouteChildren,
)

interface DashboardQuotationsRouteChildren {
  DashboardQuotationsRfqIdRoute: typeof DashboardQuotationsRfqIdRoute
}

const DashboardQuotationsRouteChildren: DashboardQuotationsRouteChildren = {
  DashboardQuotationsRfqIdRoute: DashboardQuotationsRfqIdRoute,
}

const DashboardQuotationsRouteWithChildren =
  DashboardQuotationsRoute._addFileChildren(DashboardQuotationsRouteChildren)

interface DashboardRouteChildren {
  DashboardComplaintsRoute: typeof DashboardComplaintsRouteWithChildren
  DashboardNotificationsRoute: typeof DashboardNotificationsRoute
  DashboardOrdersRoute: typeof DashboardOrdersRouteWithChildren
  DashboardProfileRoute: typeof DashboardProfileRoute
  DashboardQuotationsRoute: typeof DashboardQuotationsRouteWithChildren
}

const DashboardRouteChildren: DashboardRouteChildren = {
  DashboardComplaintsRoute: DashboardComplaintsRouteWithChildren,
  DashboardNotificationsRoute: DashboardNotificationsRoute,
  DashboardOrdersRoute: DashboardOrdersRouteWithChildren,
  DashboardProfileRoute: DashboardProfileRoute,
  DashboardQuotationsRoute: DashboardQuotationsRouteWithChildren,
}

const DashboardRouteWithChildren = DashboardRoute._addFileChildren(
  DashboardRouteChildren,
)

interface ExploreProductsProductIdRouteChildren {
  ExploreProductsProductIdVariantsVariantIdRoute: typeof ExploreProductsProductIdVariantsVariantIdRoute
}

const ExploreProductsProductIdRouteChildren: ExploreProductsProductIdRouteChildren =
  {
    ExploreProductsProductIdVariantsVariantIdRoute:
      ExploreProductsProductIdVariantsVariantIdRoute,
  }

const ExploreProductsProductIdRouteWithChildren =
  ExploreProductsProductIdRoute._addFileChildren(
    ExploreProductsProductIdRouteChildren,
  )

interface ExploreProductsRouteChildren {
  ExploreProductsProductIdRoute: typeof ExploreProductsProductIdRouteWithChildren
}

const ExploreProductsRouteChildren: ExploreProductsRouteChildren = {
  ExploreProductsProductIdRoute: ExploreProductsProductIdRouteWithChildren,
}

const ExploreProductsRouteWithChildren = ExploreProductsRoute._addFileChildren(
  ExploreProductsRouteChildren,
)

interface ExploreRouteChildren {
  ExploreProductsRoute: typeof ExploreProductsRouteWithChildren
  ExploreSuppliersRoute: typeof ExploreSuppliersRoute
  ExploreCompaniesCompanyIdRoute: typeof ExploreCompaniesCompanyIdRoute
}

const ExploreRouteChildren: ExploreRouteChildren = {
  ExploreProductsRoute: ExploreProductsRouteWithChildren,
  ExploreSuppliersRoute: ExploreSuppliersRoute,
  ExploreCompaniesCompanyIdRoute: ExploreCompaniesCompanyIdRoute,
}

const ExploreRouteWithChildren =
  ExploreRoute._addFileChildren(ExploreRouteChildren)

interface ExternalSellersRouteChildren {
  ExternalSellersLeadIdRoute: typeof ExternalSellersLeadIdRoute
}

const ExternalSellersRouteChildren: ExternalSellersRouteChildren = {
  ExternalSellersLeadIdRoute: ExternalSellersLeadIdRoute,
}

const ExternalSellersRouteWithChildren = ExternalSellersRoute._addFileChildren(
  ExternalSellersRouteChildren,
)

interface OrdersRouteChildren {
  OrdersOrderIdRoute: typeof OrdersOrderIdRoute
}

const OrdersRouteChildren: OrdersRouteChildren = {
  OrdersOrderIdRoute: OrdersOrderIdRoute,
}

const OrdersRouteWithChildren =
  OrdersRoute._addFileChildren(OrdersRouteChildren)

interface ProductsRouteChildren {
  ProductsProductIdRoute: typeof ProductsProductIdRoute
  ProductsVariantVariantIdRoute: typeof ProductsVariantVariantIdRoute
}

const ProductsRouteChildren: ProductsRouteChildren = {
  ProductsProductIdRoute: ProductsProductIdRoute,
  ProductsVariantVariantIdRoute: ProductsVariantVariantIdRoute,
}

const ProductsRouteWithChildren = ProductsRoute._addFileChildren(
  ProductsRouteChildren,
)

interface QuotationsRouteChildren {
  QuotationsQuotationIdRoute: typeof QuotationsQuotationIdRoute
}

const QuotationsRouteChildren: QuotationsRouteChildren = {
  QuotationsQuotationIdRoute: QuotationsQuotationIdRoute,
}

const QuotationsRouteWithChildren = QuotationsRoute._addFileChildren(
  QuotationsRouteChildren,
)

interface RfqsRouteChildren {
  RfqsRfqIdRoute: typeof RfqsRfqIdRoute
}

const RfqsRouteChildren: RfqsRouteChildren = {
  RfqsRfqIdRoute: RfqsRfqIdRoute,
}

const RfqsRouteWithChildren = RfqsRoute._addFileChildren(RfqsRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRoute,
  BrowseProductsRoute: BrowseProductsRouteWithChildren,
  BrowseSupplierRoute: BrowseSupplierRouteWithChildren,
  BuyerProfileSetupRoute: BuyerProfileSetupRoute,
  ChatRoute: ChatRoute,
  CompaniesRoute: CompaniesRouteWithChildren,
  ComplaintsRoute: ComplaintsRouteWithChildren,
  DashboardRoute: DashboardRouteWithChildren,
  ExploreRoute: ExploreRouteWithChildren,
  ExternalSellersRoute: ExternalSellersRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  LogisticsRoute: LogisticsRoute,
  NotificationsRoute: NotificationsRoute,
  OrdersRoute: OrdersRouteWithChildren,
  OverviewRoute: OverviewRoute,
  ProductsRoute: ProductsRouteWithChildren,
  ProfileRoute: ProfileRoute,
  QuotationsRoute: QuotationsRouteWithChildren,
  ResetPasswordRoute: ResetPasswordRoute,
  RfqsRoute: RfqsRouteWithChildren,
  SellerCompanySetupRoute: SellerCompanySetupRoute,
  SellerProfileSetupRoute: SellerProfileSetupRoute,
  SettingsRoute: SettingsRoute,
  SignupRoute: SignupRoute,
  SubmitRfqRoute: SubmitRfqRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
